
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/articles",
      function () {
        return require("private-next-pages/guides/articles.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/articles"])
      });
    }
  